export default __webpack_public_path__ + "static/media/05_jozio.73eeb9fc.png";